import { RootState } from 'shared/store/store'

import service from './messages.service'
import { MessagesSectionEnum } from '../../../models/enum'

interface MessagesState {
  messaging: {
    messages: {
      loadingMore: boolean
      section: MessagesSectionEnum
      isSendingMessage: boolean
    }
  }
}

export const getMessages =
  (section: MessagesSectionEnum) => (state: RootState) =>
    service.endpoints.getMessages.select(section)(state)

export const getMessageFromListById =
  (id: string, section: MessagesSectionEnum) => (state: RootState) =>
    service.endpoints.getMessage.select({ id, section })(state)

export const getMessageThread = (threadId: string) => (state: RootState) =>
  service.endpoints.getMessageThread.select(threadId)(state)

export const getMessagesSection = (state: MessagesState) =>
  state.messaging.messages.section

export const getIsSendingMessage = (state: MessagesState) =>
  state.messaging.messages.isSendingMessage
